
import { SwaggerUIBundle, SwaggerUIStandalonePreset } from 'swagger-ui-dist'
import 'swagger-ui-dist/swagger-ui.css'
import specOndus from '../../assets/swagger-ui/OndusAPI-v1-swagger.json'

export default {
  name: 'swagger',

  data: function () {
    return {
    }
  },
  mounted () {
    this.buildSwagger()
  },
  methods: {
    buildSwagger () {
      console.log('Building swagger tab')
      let presets = [
        SwaggerUIBundle.presets.apis,
        SwaggerUIStandalonePreset[2]
      ]
      let token = this.$store.getters.getAccessToken
      const ui = SwaggerUIBundle({
        // url: ''
        spec: specOndus,
        dom_id: '#swagger-ui',
        deepLinking: false,
        filter: true,
        presets: presets,
        plugins: [
          SwaggerUIBundle.plugins.DownloadUrl
        ],
        layout: 'StandaloneLayout',
        onComplete: () => {
          ui.preauthorizeApiKey('bearerAuth', token)
        }
      })
      window.ui = ui
    }
  },

  beforeCreate: function () {
  },

  created: function () {
    console.log('swagger')
  }
}



// WEBPACK FOOTER //
// ./src/components/swagger/swagger.js